import '/assets/styles/partials/lottery-headline.scss';

import classNames from 'classnames';

// Partials
import Img from '@wearetla/tla-essentials-tools/partials/img';

// Context
import { useTranslation } from '/utilities/i18n';

// Static Assets
import image_lottery_banner from '/assets/images/lottery/lottery-banner.jpg';

// Çekiliş kampanyasının başlığı (ana sayfa banner'ı ve çekiliş haklarım sayfası).
const LotteryHeadline = ({ className }) => {
	const { t } = useTranslation();

	return (
		<div className={classNames('lottery-headline', className)}>
			<Img
				src={image_lottery_banner}
				lazy={false}
				className="headline-image"
				alt={t("IF Sokak'tan 4 iPhone 17 ve 16 AirPods hediye")}
			/>
		</div>
	);
};

export default LotteryHeadline;
